/**
 * Utilidades YouTube para testimoniales Home V2 (thumbnail + embed).
 * Sin hacks sobre el iframe; solo parámetros estándar.
 */

const YOUTUBE_HOSTS = [
  'youtube.com',
  'www.youtube.com',
  'm.youtube.com',
  'youtu.be',
  'www.youtu.be',
  'youtube-nocookie.com',
  'www.youtube-nocookie.com',
];

export function extractYoutubeId(rawUrl: string | null | undefined): string | null {
  if (!rawUrl?.trim()) {
    return null;
  }
  let url: URL;
  try {
    url = new URL(rawUrl.trim());
  } catch {
    return null;
  }
  const host = url.hostname.toLowerCase();
  if (!YOUTUBE_HOSTS.some((h) => host === h || host.endsWith('.' + h))) {
    return null;
  }
  if (host.includes('youtu.be')) {
    const id = url.pathname.replace(/^\//, '').split('/')[0];
    return id || null;
  }
  const v = url.searchParams.get('v');
  if (v) {
    return v;
  }
  const parts = url.pathname.split('/').filter(Boolean);
  const embedIdx = parts.indexOf('embed');
  if (embedIdx >= 0 && parts[embedIdx + 1]) {
    return parts[embedIdx + 1];
  }
  const shortsIdx = parts.indexOf('shorts');
  if (shortsIdx >= 0 && parts[shortsIdx + 1]) {
    return parts[shortsIdx + 1];
  }
  return null;
}

/** Preview: hqdefault es más fiable que maxresdefault. */
export function youtubeThumbnailUrl(videoId: string): string {
  return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
}

/**
 * Normaliza a URL embed HTTPS con parámetros modestos (no ocultan el título de YT).
 */
export function toYoutubeEmbedUrl(rawUrl: string | null | undefined): string | null {
  const id = extractYoutubeId(rawUrl);
  if (!id) {
    if (rawUrl?.includes('/embed/')) {
      try {
        const u = new URL(rawUrl);
        if (u.protocol === 'https:') {
          u.searchParams.set('rel', '0');
          u.searchParams.set('modestbranding', '1');
          return u.toString();
        }
      } catch {
        return null;
      }
    }
    return null;
  }
  return `https://www.youtube.com/embed/${id}?rel=0&modestbranding=1`;
}
